import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class MissionTypeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllMissionTypes(): Observable<MissionType[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionTypeUrl}s`,
			'getAllMissionTypes'
		);
	}

	addMissionType(missionType: MissionType): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionTypeUrl}`,
			`addMissionType`,
			missionType
		);
	}

	updateMissionType(missionType: MissionType): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionTypeUrl}`,
			`updateMissionType`,
			missionType
		);
	}
}
